import { useEffect, useRef, useState } from "react";

// Returns [ref, shown]. `shown` flips true once the element scrolls into view.
export default function useReveal(options) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShown(true);
          io.unobserve(el);
        }
      },
      { threshold: 0.12, ...(options || {}) }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [options]);

  return [ref, shown];
}
